import Header from '../../__Layout/Header';
import React , {useState} from "react";
import { useForm } from "react-hook-form";
import Loader from '../../utils/Loader';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from 'react-toastify';
import { useSendMessageMutation ,useGetStudentListQuery} from "../../Services/api";

export default function Index() {
    const validationSchema = Yup.object().shape({
        student_id: Yup.string().required("student fields is required"),
        subject: Yup.string().required("subject fields is required"),
        message: Yup.string().required("message  fields is required"),
    });
    let defaultValues = { name: ""};
    const notify = () => '';
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues,
    });
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = methods;
    const [SendMessage,isLoading] = useSendMessageMutation();
    const onSubmit = (values,e) => {
        SendMessage({ data: values })
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    const { 
        data: StudentList        
    } = useGetStudentListQuery();
      return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title">Write New Message</h5>
                        <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                            <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                                <section className="section">
                                    <div className="row">
                                    <div className="col-lg-2"></div>
                                        <div className="col-lg-10">
                                            <form onSubmit={handleSubmit(onSubmit)} >
                                                    <div className="row mb-3">
                                                        <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">student</label>
                                                        <div className="col-sm-10">
                                                            <select  {...register("student_id")} className="form-control">
                                                            <option value="">Select student</option>   
                                                            {                            
                                                            StudentList?.data?.map((item) => {
                                                                return (
                                                                    <option key={item.student_id} value={item.email}>{item.first_name} {item.last_name}</option>                                           
                                                                    )
                                                                })
                                                            }
                                                            </select>
                                                            <span className="text-danger">{errors.student_id?.message}</span>
                                                        </div>
                                                    </div> 
                                                    <div className="row mb-3">
                                                        <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Subject</label>
                                                        <div className="col-sm-10">
                                                            <input type="text" {...register("subject")} className="form-control" />
                                                            <span className="text-danger">{errors.subject?.message}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Message</label>
                                                        <div className="col-sm-10">
                                                            <textarea rows="7" {...register("message")} className="form-control"></textarea>
                                                            <span className="text-danger">{errors.message?.message}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <label className="col-sm-2 col-form-label"></label>
                                                        <div className="col-sm-10">
                                                        {isLoading.status !='pending' ? 
                                                
                                                            <button type="submit" className="btn btn-warning w-100" >Send Message</button>
                                                            :
                                                            <button type="submit" className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                                        }
                                                        </div>
                                                    </div>
                                            </form>
                                        </div>
                                    </div>
                                </section>  
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
